import { Flex } from '@osmosis/react-ui/components/Box';
import { Box } from '@osmosis/react-ui/components/Box';
import { P } from '@osmosis/react-ui/components/Text';
import { FormattedMessage } from 'react-intl';

const Line = () => <Box height="1px" width="100%" bg="gray10" flex={1} />;

/**
 * Text Divider.
 */
export const TextDivider = () => {
  return (
    <Flex alignItems="center" width="100%">
      <Line />
      <Box mx={3}>
        <P
          width="100%"
          color="gray40"
          textAlign="center"
          fontWeight={700}
          fontSize={15}
        >
          <FormattedMessage
            id="quiz.textDivider.rate-your-confidence"
            defaultMessage="Rate your confidence"
          />
        </P>
      </Box>
      <Line />
    </Flex>
  );
};
